import pick from 'lodash/pick'

const getPropsData = ({ selectedProps, data }) => {
  return pick(data, selectedProps)
}

export default getPropsData
